import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { robotsOption, statusOption } from "../../../constant";
import { useAddService } from "./hooks";
import {
  useComponent,
  useElement,
  useLocale,
  useService,
} from "../../../hooks";

export const AddService = () => {
  const { t } = useLocale();
  const { toIndianCurrency, generateUID } = useService("Misc");
  const Button = useElement("Button");
  const BackIcon = useElement("BackIcon");
  const DatePicker = useElement("DatePicker");
  const Editor = useElement("Editor");
  const Input = useElement("Input");
  const Img = useElement("Img");
  const Box = useComponent("Box");
  const MediaBox = useComponent("MediaBox");
  const {
    setshowCarListBox,
    removePrice,
    serviceTitle,
    addService,
    title,
    addTitle,
    slug,
    setslug,
    sku,
    setsku,
    metaTitle,
    setmetaTitle,
    featuredVideo,
    setfeaturedVideo,
    hsn,
    sethsn,
    content,
    setcontent,
    userNote,
    setuserNote,
    excerpt,
    setexcerpt,
    showCarList,
    showCarListBox,
    vehicleClassList,
    activeCar,
    activePrice,
    saleprice,
    setactivePrice,
    setsaleprice,
    setactiveCar,
    derivedPrices,
    prices,
    setprices,
    css,
    setcss,
    js,
    setjs,
    canonical,
    setcanonical,
    activeRobots,
    setrobots,
    metaDescription,
    setmetaDescription,
    setmetaKeyword,
    keywordOptions,
    metaKeyword,
    renderSlug,
    toggleRenderSlug,
    selectedTaxClass,
    settax,
    taxClassData,
    serviceTime,
    setserviceTime,
    setpublishDate,
    publishDate,
    setinclusiveTax,
    inclusiveTax,
    setisFeatured,
    isFeatured,
    setisAutoApproved,
    isAutoApproved,
    activeStatus,
    setstatus,
    status,
    company,
    setcompany,
    companies,
    category,
    setcategory,
    categoryOptions,
    tag,
    settag,
    tagOptions,
    image,
    setimage,
    icon,
    seticon,
  } = useAddService();

  const renderCarList = (carList) => {
    return carList.map((item, index) => {
      let activeClass = "";
      if (activeCar !== null)
        activeClass = activeCar.slug === item.slug ? "active" : "";
      if (item.slug === item.priceGroup)
        return (
          <li
            key={index}
            className={activeClass}
            onClick={() => {
              item.price = activePrice;
              setactiveCar(item);
              setshowCarListBox(false);
            }}
          >
            <Img alt={item.name} source="carCDN" src={item.image} />
            <p>{item.name}</p>
          </li>
        );
      else return false;
    });
  };

  const renderPriceList = (priceList) => {
    return priceList.map((item, index) => {
      return (
        <li key={index}>
          <Img alt={item.name} source="carCDN" src={item.image} />
          <p className="car-name">{item.name}</p>
          <p className="service-price">{toIndianCurrency(item.price)}</p>
          <p className="service-price">{toIndianCurrency(item.saleprice)}</p>
          <i className="hi-trash remove" onClick={() => removePrice(item)}></i>
        </li>
      );
    });
  };

  return (
    <div id="content-box" className="content">
      <h1>
        <BackIcon backLink="/admin/service/list" />
        {serviceTitle}
      </h1>
      <form className="columns" noValidate onSubmit={addService}>
        <div className="left">
          <Box title={t("title")} required>
            <Input
              autoFocus
              required
              name="title"
              value={title}
              onChange={addTitle}
            />
          </Box>
          <Box title="Slug" required>
            <Input
              required
              name="slug"
              value={slug}
              onChange={(e) => setslug(e.target.value)}
            />
          </Box>
          <Box title={t("sku")}>
            <Input
              name="sku"
              value={sku}
              onChange={(e) => setsku(e.target.value)}
            />
          </Box>
          <Box title={t("hsnCode")}>
            <Input
              name="hsn"
              value={hsn}
              onChange={(e) => sethsn(e.target.value)}
            />
          </Box>
          <Box title="Content" required>
            <Editor
              value={content}
              onEditorChange={(content) => setcontent(content)}
            />
          </Box>
          <Box title={t("userNote")}>
            <Editor
              value={userNote}
              onEditorChange={(userNote) => setuserNote(userNote)}
            />
          </Box>
          <Box title={t("excerpt")} required>
            <Editor
              initialValue={excerpt}
              value={excerpt}
              onEditorChange={(content) => setexcerpt(content)}
            />
          </Box>
          <Box title="Prices" required bodyClass="relative">
            <div className="form-inline">
              {activeCar === null ? (
                <Button className="showCarList" onClick={showCarList}>
                  Show Car List
                </Button>
              ) : (
                <div className="selected-car-type" onClick={showCarList}>
                  <Img
                    alt={activeCar.name}
                    source="carCDN"
                    src={activeCar.image}
                  />
                  <p>{activeCar.name}</p>
                </div>
              )}
              {showCarListBox && (
                <ul className="scroll-box">
                  {renderCarList(vehicleClassList || [])}
                </ul>
              )}
              <Input
                className="input"
                type="number"
                required
                name="activePrice"
                value={activePrice || ""}
                placeholder="Enter MRP"
                onChange={(e) => setactivePrice(e.target.value)}
              />
              <Input
                className="input"
                type="number"
                required
                name="saleprice"
                value={saleprice || ""}
                placeholder="Enter Sale Price"
                onChange={(e) => setsaleprice(e.target.value)}
              />
              <span
                className="btn btn-icon"
                onClick={() => {
                  let car = activeCar;
                  if (activePrice !== "" && activeCar !== null) {
                    car.price = activePrice;
                    car.saleprice = saleprice;
                    car.uid = generateUID();
                    derivedPrices.push(car);
                    setprices(JSON.stringify(derivedPrices));
                    setactivePrice("");
                    setsaleprice("");
                    setactiveCar(null);
                  }
                }}
              >
                <i className="hi-add-circle"></i>
              </span>
            </div>
            {derivedPrices.length !== 0 && (
              <ul className="prices-list">
                {renderPriceList(derivedPrices || [])}
              </ul>
            )}
            <Input
              className="hidden"
              required
              name="prices"
              value={prices || "[]"}
              onChange={(e) => setprices(e.target.value)}
            />
          </Box>

          <Box title="CSS">
            <textarea
              className="description"
              placeholder={t("placeholder.inlineCss")}
              required
              name="css"
              value={css}
              onChange={(e) => setcss(e.target.value)}
            ></textarea>
          </Box>
          <Box title="JS">
            <textarea
              className="description"
              placeholder={t("placeholder.inlineJs")}
              required
              name="js"
              value={js}
              onChange={(e) => setjs(e.target.value)}
            ></textarea>
          </Box>
          <Box title={t("canonicalUrl")}>
            <Input
              required
              name="canonical"
              value={canonical}
              onChange={(e) => setcanonical(e.target.value)}
            />
          </Box>
          <Box title={t("robots")}>
            <Select
              value={activeRobots}
              defaultValue={activeRobots}
              onChange={(e) => setrobots(e.value)}
              options={robotsOption}
            />
          </Box>
          <Box title={t("metaTitle")}>
            <Input
              name="metaTitle"
              value={metaTitle}
              onChange={(e) => setmetaTitle(e.target.value)}
            />
          </Box>
          <Box title={t("metaDescription")}>
            <textarea
              placeholder={t("placeholder.metaDescription")}
              required
              name="metaDescrition"
              value={metaDescription}
              onChange={(e) => setmetaDescription(e.target.value)}
            ></textarea>
          </Box>
          <Box title={t("metaKeywords")}>
            <CreatableSelect
              isMulti
              onChange={(e) => setmetaKeyword(e)}
              options={keywordOptions}
              value={metaKeyword}
            />
          </Box>
        </div>
        <div className="right">
          <Box title={t("meta")}>
            <p>
              {t("renderSlug")}:
              <span
                className={renderSlug ? "switch on" : "switch off"}
                title="Click to Enable/Disable auto slug rendering"
                onClick={toggleRenderSlug}
              ></span>
            </p>
            <Button
              className="btn btn-primary has-icon"
              type="submit"
              title="Click here to save"
            >
              {t("save")}
            </Button>
          </Box>
          {taxClassData.length > 0 && (
            <Box title={t("taxPercentage")} required>
              <Select
                value={selectedTaxClass}
                defaultValue={selectedTaxClass}
                onChange={(e) => settax(e.value)}
                options={taxClassData}
              />
            </Box>
          )}
          <Box title="Service Time">
            <Input
              required
              name="serviceTime"
              min={0}
              value={serviceTime || ""}
              onChange={(e) => setserviceTime(e.target.value)}
            />
          </Box>
          <Box title={t("publishDate")}>
            <DatePicker
              onChange={(publishDate) => setpublishDate(publishDate)}
              selected={publishDate}
            />
          </Box>
          <Box title={t("priceMeta")} required>
            <span
              className="pointer isFeatured"
              onClick={() => setinclusiveTax(!inclusiveTax)}
            >
              {inclusiveTax ? (
                <i className="icon-check orange hi-check-circle"></i>
              ) : (
                <i className="hi-circle icon-check"></i>
              )}
              Inclusive of all taxes{" "}
            </span>
          </Box>
          <Box title="Featured">
            <span
              className="pointer isFeatured"
              onClick={() => setisFeatured(!isFeatured)}
            >
              {isFeatured ? (
                <i className="icon-check orange hi-check-circle"></i>
              ) : (
                <i className="hi-circle icon-check"></i>
              )}
              {t("isFeatured")}
            </span>
          </Box>
          <Box title="Auto Approved">
            <span
              className="pointer isAutoApproved"
              onClick={() => setisAutoApproved(!isAutoApproved)}
            >
              {isAutoApproved ? (
                <i className="icon-check orange hi-check-circle"></i>
              ) : (
                <i className="hi-circle icon-check"></i>
              )}
              Is Auto Approved{" "}
            </span>
          </Box>
          <Box title="Status">
            <Select
              value={activeStatus}
              defaultValue={activeStatus}
              onChange={(e) => setstatus(e.value)}
              options={statusOption}
            />
          </Box>
          {status === "private" && (
            <Box title="Company" required>
              <Select
                value={company}
                defaultValue={company}
                onChange={(e) => setcompany(e)}
                options={companies}
              />
            </Box>
          )}
          <Box title="Category">
            <Select
              value={category}
              onChange={(e) => setcategory(e)}
              options={categoryOptions}
              isMulti
            />
          </Box>
          <Box title="Tags">
            <CreatableSelect
              isMulti
              value={tag}
              onChange={(e) => settag(e)}
              options={tagOptions}
            />
          </Box>
          <MediaBox
            image={image}
            setimage={(image) => setimage(image)}
            id="image"
            usage={["service"]}
          />
          <MediaBox
            title="Icon"
            image={icon}
            setimage={(icon) => seticon(icon)}
            id="icon"
            usage={["icon"]}
          />
          <Box title={t("featuredVideo")}>
            <Input
              name="featuredVideo"
              value={featuredVideo}
              onChange={(e) => setfeaturedVideo(e.target.value)}
            />
          </Box>
        </div>
      </form>
    </div>
  );
};
